export const labelStyle = {
    fontFamily: 'Inter, sans-serif',
    color: '#6c757d',
    fontSize: 14,
    fontWeight: 600, // <- slightly bolder
};

export const titleStyle = {
    fontFamily: 'Inter, sans-serif',
    fill: '#6c757d',
    fontSize: 15,
    fontWeight: 650, // <- bolder for titles
};